type NicheTestMode = "ui" | "fullstack" | "";

const nicheTestMode: NicheTestMode =
  import.meta.env.VITE_NICHE_TEST_MODE === "ui" ||
  import.meta.env.VITE_NICHE_TEST_MODE === "fullstack"
    ? import.meta.env.VITE_NICHE_TEST_MODE
    : "";

export const isUiFixtureMode = nicheTestMode === "ui";
export const isFullStackTestMode = nicheTestMode === "fullstack";

export const UI_FIXTURE_SCOPE = {
  organization_id: "org_demo",
  legal_entity_id: "le_demo",
} as const;
